export const airlines = {
  groups: [
    ["0J-PREMIUMJET-DE", "0J-PREMIUMJETAG-CH"],
    ["OG-GHODAWATENTERPR-IN", "SDG-STARAIR-IN", "SRR-STARAIRAS-DK", "XT-SKYSTARAIRWAYS-TH"],
    ["0V-VIETNAMAIRSERVI-VN", "VN-VIETNAMAIRLINES-VN", "VU-VIETRAVELAIRLIN-VN"],
    ["2D-DYNAMICAIRWAYS-US", "EAL-EASTERNAIRLINES-US"],
    ["2F-FRONTIERFLYINGS-US", "F9-FRONTIERAIRLINE-US", "FTA-FRONTIERFLYINGS-US"],
    ["2F-TWOTAXIAEREOLTD-BR", "AD-AZULAIRLINES-BR"],
    [
      "2K-AEROGAL-EC",
      "A0-AVIANLINEASAERE-AR",
      "ANC-AVIANCAARGENTIN-AR",
      "AV-AVIANCA-CO",
      "LR-LACSALINEASAERE-CR",
      "O6-OCEANAIR-BR",
      "T0-TRANSAMERICANAI-PE",
    ],
    ["2M-MAYAISLANDAIR-BZ", "MY-MAYAISLANDAIR-BZ"],
    ["2P-AIRPHILIPPINES-PH", "PR-PHILIPPINEAIRLI-PH"],
    ["2R-ATLANTISEUROPEA-RO", "TD-ATLANTISEUROPEA-AM"],
    ["2W-WORLD2FLY-ES", "3P-WORLD2FLYPORTUG-PT"],
    ["K4-KALITTAAIR-US", "K5-KALITTACHARTERS-US", "K9-KALITTACHARTERS-US"],
    ["3A-ALLIANCEAIRLINE-US", "9I-AIRINDIAREGIONA-IN", "QQ-ALLIANCEAIRLINE-AU"],
    ["3F-FLYONEARMENIA-AM", "5F-FLYONESRL-MD", "OE-FLYONEAIRLINES-RO"],
    [
      "5W-WIZZAIRABUDHABI-AE",
      "W4-WIZZAIRMALTA-MT",
      "W6-WIZZAIR-HU",
      "W9-WIZZAIRUK-GB",
      "WU-WIZZAIRUKRAINE-UA",
      "8Z-WIZZAIRBULGARIA-BG",
    ],
    ["3J-JUBBAAIRWAYS-SO", "3J-JUBBAAIRWAYSLTD-KE", "JUB-JUBBAAIRWAYS-SO"],
    ["3K-JETSTARASIA-SG", "GK-JETSTARJAPAN-JP", "JQ-JETSTARAIRWAYS-AU"],
    [
      "3L-AIRARABIAABUDHA-AE",
      "3O-AIRARABIAMAROC-MA",
      "9P-AIRARABIAJORDAN-JO",
      "E5-AIRARABIAEGYPT-EG",
      "G9-AIRARABIA-AE",
    ],
    ["3M-SILVERAIRWAYSCO-US", "SLD-SILVERAIR-CZ"],
    ["3R-AVIORREGIONAL-VE", "9V-AVIORAIRLINES-VE", "RGR-AVIORREGIONAL-VE"],
    ["3X-JAPANAIRCOMMUTE-JP", "JC-JALEXPRESS-JP", "JL-JAPANAIRLINES-JP"],
    ["3Z-TRAVELSERVICEPO-PL", "6D-TRAVELSERVICESL-SK", "7O-SMARTWINGSHUNGA-HU", "QS-SMARTWINGS-CZ"],
    ["4B-PERIMETERAVIATI-CA", "JV-BEARSKINLAKEAIR-CA", "YP-PERIMETERAVIATI-CA"],
    ["4E-STABOAIR-ZM", "SBO-STABOAIR-ZM"],
    ["4E-TANANAAIRSERVIC-US", "TNR-TANANAAIRSERVIC-US"],
    ["4J-FLYDAMASAIRLINE-SY", "FDK-FLYDAMASAIRLINE-SY"],
    [
      "4K-FREEDOMAIRLINEE-SO",
      "FDM-FREEDOMAIRLINES-US",
      "FDT-FREEDOMAIRLINEE-KE",
      "FP-FREEDOMAIR-GU",
    ],
    ["4O-INTERJET-MX", "K8-INTERJETWEST-US"],
    ["D6-SERVICIOSAEREOS-DO", "S6-SUNRISEAIRWAYS-HT"],
    ["4V-BVIAIRWAYS-VG", "XV-BVIAIRWAYS-VG"],
    [
      "4Z-SOUTHAFRICANAIR-ZA",
      "8N-BARENTSAIRLINK-SE",
      "DR-AIRLINK-AU",
      "EA-ATLANTISAIRLINK-CA",
      "I4-INTERNATIONALAI-JM",
      "LZ-AIRLINK-AU",
      "NYS-ULENDOAIRLINK-MW",
      "V4-VIEQUESAIRLINK-PR",
      "V6-BVIAIRLINK-VG",
      "V6-VIAIRLINK-VG",
      "VIL-VIAIRLINK-VG",
      "YZ-ZIMBABWEAIRLINK-ZW",
    ],
    ["5B-EUROASIAAIRINTE-KZ", "6Z-EUROASIAAIR-KZ"],
    ["5C-CALCARGOAIRLINE-IL", "X7-ACEBELGIUMFREIG-BE"],
    ["5D-AEROMEXICOCONNE-MX", "AM-AEROMEXICO-MX"],
    ["5J-CEBUPACIFICAIR-PH", "DG-CEBGO-PH"],
    [
      "3V-TNTAIRWAYSSA-BE",
      "5O-ASLAIRLINESFRAN-FR",
      "5O-EUROPEAIRPOST-FR",
      "AG-ASLAIRLINESIREL-IE",
      "FAT-ASLAIRLINESSWIT-CH",
    ],
    [
      "5P-SMALLPLANETAIRL-DE",
      "P7-SMALLPLANETAIRL-PL",
      "RD-SMALLPLANETAIRL-KH",
      "S5-SMALLPLANETAIRL-LT",
    ],
    ["EO-AIRGO-EG", "EO-AIRGOAIRLINESEG-EG", "G8-GOAIR-IN", "G8-GOFIRST-IN"],
    ["5R-RUTACA-VE", "RUC-RUTACA-VE"],
    ["5S-GLOBALAVIATIONA-LY", "GE-GLOBALAVIATIONO-ZA", "QG-GLOBALAVIATION-ZA"],
    [
      "4C-AIRES-CO",
      "JJ-TAMLINHASAEREAS-BR",
      "LA-LANAIRLINES-CL",
      "LP-LANPERU-PE",
      "PZ-TRANSPORTESAERE-PY",
      "XL-LANECUADOR-EC",
    ],
    ["5Z-BISMILLAHAIRLIN-BD", "BH-BISMILLAHAIRLIN-BD"],
    [
      "6B-TUIFLYNORDIC-SE",
      "OR-TUIFLYNETHERLAN-NL",
      "TB-JETAIRFLY-BE",
      "TOM-THOMSONAIRWAYS-GB",
      "X3-TUIFLY-DE",
    ],
    ["6C-AIRTIMOR-TL", "6C-AIRTIMORSA-TL"],
    ["6F-PRIMERAAIRNORDI-LV", "PF-PRIMERAAIR-DK"],
    ["6N-ALNASERAIRLINES-JO", "NR-ALNASERAIRLINES-IQ", "QL-LASERAIRLINES-VE"],
    [
      "6Q-CHAMWINGSAIRLIN-SY",
      "IW-WINGSAIR-ID",
      "ND-SKYWINGSAIRLINE-GR",
      "WZ-REDWINGSAIRLINE-RU",
      "YJ-ASIANWINGSAIRWA-MM",
    ],
    ["6S-SAUDIGULFAIRLIN-SA", "GF-GULFAIR-BH", "GX-GUANGXIBEIBUGUL-CN"],
    ["6Y-SMARTLYNXAIRLIN-LV", "LYX-SMARTLYNXAIRLIN-MT", "MYX-SMARTLYNXAIRLIN-EE", "Y9-ENERJET-CA"],
    ["7B-BBNAIRLINESINDO-ID", "B5-BBNAIRLINES-TR"],
    ["7B-BEESAIRLINE-UA", "E8-BEESAIRLINES-RO"],
    [
      "7H-ERAAVIATION-US",
      "8Y-ASTROAIRINTERNA-PH",
      "BL-JETSTARPACIFICA-VN",
      "P9-ASIAPACIFICAIRL-GU",
    ],
    ["7I-INSELAIR-CW", "8I-INSELAIRARUBA-AW"],
    ["OO-SKYWESTAIRLINES-US", "XR-SKYWESTAIRLINES-AU"],
    ["7N-NATIONALAIRWAYS-ET", "9Y-NATIONALAIRWAYS-ET", "NAE-NATIONALAIRWAYS-ET"],
    [
      "8I-ITA-BR",
      "CT-ALITALIACITYLIN-IT",
      "FS-ITALIAIRLINES-IT",
      "I9-AIRITALY-IT",
      "IG-MERIDIANAFLYSPA-IT",
      "ITY-ITAAIRWAYS-IT",
      "IU-SWITALIASPA-IT",
    ],
    ["8B-TRANSNUSA-ID", "TNU-TRANSNUSA-ID"],
    ["8CR-JONAIR-SE", "JON-JONAIR-SE"],
    ["8CX-AIRLIAISON-CA", "LIZ-AIRLIAISON-CA", "LSJ-AIRLIAISON-CA", "MAX-AIRLIAISON-CA"],
    ["8CY-AEROMEXPRESS-MX", "MPX-AEROMEXPRESS-MX"],
    ["8N-REGIONALAIRSERV-TZ", "REG-REGIONALAIRSERV-TZ"],
    ["8R-SOLLINEASAEREAS-AR", "FQ-SOLSALINEASAERE-AR"],
    ["8V-ASTRALAVIATION-KE", "CQ-COASTALAVIATION-TZ"],
    ["8W-PRIVATEWINGS-DE", "JW-PRIVATEWINGSFLU-DE"],
    ["EPR-EXPRESSAIRWAYS-DE", "WEW-EXPRESSAIR-CA", "XAR-XPRESSAIR-ID", "XN-XPRESSAIR-ID"],
    ["9C-SPRINGAIRLINES-CN", "IJ-SPRINGAIRLINESJ-JP"],
    ["9L-COLGANAIR-US", "CJC-COLGANAIR-US"],
    ["9W-JETAIRWAYSINDIA-IN", "O2-JETAIR-PL", "O2-JETAIRLTD-PL", "QJ-JETAIRWAYSINC-US"],
    ["A0-MACAIRJET-AR", "CC-MACAIR-AU", "MCJ-MACAIRJET-AR"],
    ["A4-AEROCON-BO", "NIG-AEROCONTRACTORS-NG"],
    ["KL-KLMROYALDUTCHAI-NL", "UK-KLMUK-GB", "WA-KLMCITYHOPPER-NL"],
    [
      "BU-BRAATHENSASA-NO",
      "DC-BRAATHENSREGION-SE",
      "TF-BRAATHENSREGION-SE",
      "TT-BRAATHENSINTERN-SE",
    ],
    ["AC-AIRCANADA-CA", "QK-AIRCANADAJAZZ-CA", "RV-AIRCANADAROUGE-CA"],
    ["ACL-AEROLINEADELCAR-CO", "CPR-AEROLINEADELCAR-PE", "JK-AEROLINEADELCAR-CO"],
    ["AEU-ATLANTISARMENIA-AM", "JI-ARMENIANAIRLINE-AM"],
    ["AI-AIRINDIA-IN", "I5-AIRASIAINDIA-IN", "IX-AIRINDIAEXPRESS-IN"],
    [
      "AK-AIRASIA-MY",
      "D7-AIRASIAX-MY",
      "DJ-AIRASIAJAPAN-JP",
      "DM-ASIANAIR-TH",
      "FD-THAIAIRASIA-TH",
      "JW-AIRASIAJAPANCOL-JP",
      "KT-AIRASIACAMBODIA-KH",
      "PQ-AIRASIAPHILIPPI-PH",
      "QZ-INDONESIAAIRASI-ID",
      "XT-INDONESIAAIRASI-ID",
      "Z2-AIRASIAZEST-PH",
      "Z2-ZESTAIR-PH",
    ],
    ["AP-AIRONE-IT", "CT-AIRONECITYLINER-IT"],
    ["APP-AEROPERLAS-PA", "WL-AEROPERLAS-PA"],
    ["ARB-AIRBAHNINC-US", "UN-AIRBAHNINC-US"],
    [
      "DG-TIGERAIRPHILIPP-PH",
      "IT-TIGERAIRTAIWANC-TW",
      "TT-TIGERAIRAUSTRAL-AU",
      "TT-TIGERAIRWAYSAUS-AU",
    ],
    ["AUZ-AMASZONASURUGUA-UY", "Z8-AMASZONAS-BO", "ZP-AMASZONASLINEAA-BO"],
    ["AY-NORDICREGIONALA-FI", "N7-NORDICREGIONALA-FI"],
    ["AYD-ABAVIATION-KM", "Y6-ABAVIATION-KM"],
    ["AZD-ZIMEXAVIATIONAU-AT", "XM-ZIMEXAVIATION-CH"],
    ["B3-BHUTANAIRLINES-BT", "BTN-BHUTANAIRLINES-BT", "KB-DRUKAIR-BT"],
    ["B9-IRANAIRTOURS-IR", "IR-IRANAIR-IR"],
    ["EZ-SUNAIROFSCANDIN-DK", "S6-SUNAIR-SD"],
    ["BIC-ALPHALANDAVIATI-PH", "C9-ALPHALANDAVIATI-PH"],
    ["BRJ-BORAJET-TR", "YB-BORAJET-TR"],
    ["BUC-EUROPEANAIRCHAR-BG", "H6-BULGARIANAIRCHARTER-BG"],
    ["H2-SKYAIRLINE-CL", "H8-SKYAIRLINESPERU-PE", "Y3-SKYKGAIRLINES-KG", "ZY-SKYAIRLINES-TR"],
    ["C4-CONQUESTAIRINC-US", "QAI-CONQUESTAIRINC-US"],
    ["C8-CRONOSAIR-GQ", "CRA-CRONOSAIR-GQ"],
    ["CB-SCOTAIRWAYS-GB", "SAY-SCOTAIRWAYS-GB"],
    ["CC-CMAIRLINES-HN", "XK-CCMAIRLINES-FR"],
    ["CL-LUFTHANSACITYLI-DE", "LH-LUFTHANSAGERMAN-DE", "VL-CITYAIRLINES-DE"],
    ["CND-CORENDONDUTCHAI-NL", "CXI-CORENDONAIRLINE-MT", "XC-CORENDONAIRLINE-TR"],
    ["CPN-CASPIANAIRLINES-IR", "RV-CASPIANAIRLINES-IR"],
    ["CRG-COSTARICAGREENA-CR", "GW-COSTARICAGREENA-CR"],
    ["CTB-THOMASCOOKAIRLI-ES", "H5-THOMASCOOKAIRLI-ES", "MT-THOMASCOOKAIRLI-GB"],
    ["D0-DHLAIR-GB", "Q7-DHLAIRAUSTRIAGM-AT"],
    ["D3-DAALLOAIRLINES-DJ", "D9-DAALLOAIRLINESS-SO"],
    ["D4-ALIDAUNIA-IT", "LID-ALIDAUNIA-IT"],
    ["D8-NORWEGIAN-SE", "DY-NORWEGIANAIRSHU-NO"],
    ["DE-CONDORFLUGDIENS-DE", "DF-CONDORBERLIN-DE"],
    ["DH-DOUNIAHAIRLINES-ML", "DTS-DOUNIAHAIRLINES-ML"],
    ["DJ-AIRDJIBOUTI-DJ", "DZ-DJIBOUTIAIR-DJ"],
    ["DM-STERLINGBLUE-DK", "QI-CIMBERSTERLING-DK", "SNB-STERLING-DK"],
    ["DO-AIRVALLEE-IT", "VK-AIRVALLEE-IT"],
    ["DS-EASYJETSWITZERL-CH", "EC-EASYJETEUROPEAI-AT", "U2-EASYJET-GB"],
    ["DU-SKYJETMGINC-CA", "Q9-SKYJETMGINC-CA"],
    ["DX-DANISHAIRTRANSP-DK", "R6-DOTLT-LT"],
    ["E6-EUROWINGSEUROPE-MT", "EW-EUROWINGS-DE", "EWE-EUROWINGSEUROPE-AT"],
    ["E7-EQUAFLIGHT-CD", "L8-EQUAFLIGHTGABON-GA"],
    ["EA-EASTHORIZONAIRL-AF", "EHN-EASTHORIZONAIRL-AF", "HAT-AIRHORIZONT-MT", "QX-HORIZONAIR-US"],
    ["EC-OPENSKIES-GB", "LV-LEVEL-ES", "VK-ANISECLUFTFAHRT-AT"],
    ["ECB-EUROPEANCOASTAL-HR", "WL-EUROPEANCOASTAL-HR"],
    ["EE-EASTERNSKYJETS-AE", "ESJ-EASTERNSKYJETS-AE"],
    ["EG-AERLINGUSUKLIMI-GB", "EI-AERLINGUS-IE"],
    ["EGU-EAGLEAIR-UG", "FEI-EAGLEAIRICELAND-IS", "H7-EAGLEAIR-UG", "NY-AIRICELAND-IS"],
    ["EJ-ECAIR-CG", "LC-ECAIR-CG"],
    ["EJ-NEWENGLANDAIRLI-US", "NEA-NEWENGLANDAIRLI-US"],
    ["EMZ-ETHIOPIANMOZAMB-MZ", "ZU-ETHIOPIANMOZAMB-MZ"],
    ["ESS-THAIEASTARJET-TH", "ZE-EASTARJET-KR"],
    ["EX-REGIONALEXPRESS-CO", "ZL-REGIONALEXPRESS-AU"],
    ["F7-LTDIFLY-RU", "I4-IFLYLTD-RU"],
    ["FAT-FARNAIRSWITZERL-CH", "FT-FARNAIRSWITZERL-CH"],
    ["FC-FINNCOMMAIRLINE-FI", "WBA-FINNCOMMAIRLINE-FI"],
    ["FG-ARIANAAFGHANAIR-AF", "HN-AFGHANAIRLINES-AF"],
    ["FGG-FLYGLOBALCHARTE-MY", "FS-FLYGLOBALCHARTE-MY"],
    ["FH-FREEBIRDAIRLINE-TR", "FHM-FREEBIRDAIRLINE-MT"],
    ["FHE-HELLO-CH", "H3-HELLOAIRLINES-BD", "HLJ-HELLOJETS-RO"],
    ["FLB-FLYART-TD", "T2-FLYART-TD"],
    ["FLG-FLYBIG-IN", "S9-FLYBIG-IN"],
    ["FO-FELIXAIRWAYS-YE", "FXX-FELIXAIRWAYS-YE"],
    ["FR-RYANAIR-IE", "RK-RYANAIRUKLTD-GB"],
    ["FS-SYPHAXAIRLINES-TN", "SYA-SYPHAXAIRLINES-TN"],
    ["FZW-FLYAFRICAZIMBAB-ZW", "Z7-FLYAFRICAZIMBAB-ZW"],
    ["ON-OURAIRLINE-NR", "U6-URALAIRLINES-RU", "UD-URAIRLINES-IQ"],
    ["G6-GHADAMESAIRTRAN-LY", "NJ-GHADAMESAIRTRAN-LY"],
    ["GH-GLOBUSLLC-RU", "XT-GLOBUS-RU"],
    ["GM-TRIMGAIRLINES-ID", "TMG-TRIMGAIRLINES-ID"],
    ["GQ-SKYEXPRESSSA-GR", "XW-SKYEXPRESS-RU"],
    ["GRB-PHOENIXAIRGROUP-US", "PH-PHOENIXAIRGROUP-US"],
    ["GS-TIANJINAIRLINES-CN", "LJ-JINAIR-KR"],
    ["H1-HAHNAIRSYSTEMS-DE", "HR-HAHNAIR-DE", "X1-HAHNAIRTECHNOLO-DE"],
    ["H4-HISKYEUROPESRL-RO", "H7-HISKY-MD"],
    ["H8-AURICAIRSERVICE-TZ", "UI-AURICAIR-TZ"],
    ["HBN-HIBERNIANAIRLIN-IE", "HG-HIBERNIANAIRLIN-IE"],
    ["HC-HOLIDAYSCZECHAI-CZ", "OK-CZECHAIRLINES-CZ"],
    ["HS-SKYWAYSREGIONAL-SE", "JZ-SKYWAYS-SE", "K8-ZAMBIASKYWAYS-ZM"],
    ["I2-IBERIAEXPRESS-ES", "IB-IBERIA-ES"],
    ["I6-MEXICANAINTER-MX", "MX-MEXICANADEAVIAC-MX", "XN-MEXICANA-MX"],
    ["I7-INTERILESAIR-KM", "IIA-INTERILESAIR-KM"],
    ["ID-BATIKAIR-ID", "OD-BATIKAIRMALAYSI-MY"],
    ["IRG-IRANIANNAFTAIRL-IR", "KRU-KARUNAIRLINES-IR"],
    ["J6-JETSMARTAIRLINE-CO", "JA-JETSMART-CL", "JZ-JETSMARTAIRLINE-PE", "WJ-JETSMARTAIRLINE-AR"],
    ["JB-HELIJETINTERNAT-CA", "M6-AMERIJETINTERNA-US"],
    ["JCC-JCCAMBODIAINTER-KH", "QD-JCCAMBODIAINTER-KH"],
    ["JN-JOON-FR", "JON-JOON-FR"],
    ["JO-JETTIME-DK", "JP-JETTIME-DK"],
    ["JT-LIONAIR-ID", "SL-THAILIONAIR-TH"],
    ["KK-ATLASJETAIRLINE-TR", "UH-AIRCOMPANYATLAS-UA"],
    ["KN-CHINAUNITEDAIRL-CN", "UA-UNITEDAIRLINES-US"],
    ["KNW-KENAIAVIATIONOP-US", "KW-KENAIAVIATIONOP-US"],
    ["L0-LIZAVIATIONBF-BF", "LAZ-LIZAVIATIONBF-BF"],
    ["L4-GRUPOLASASRL-AR", "NQN-GRUPOLASASRL-AR"],
    ["L9-BELLEAIREUROPE-IT", "LZ-BELLEAIR-AL"],
    ["LB-AIRCOSTA-IN", "RI-AIRCOSTARICA-CR"],
    ["LCT-TARAEROLINEAS-MX", "YQ-TARAEROLINEAS-MX"],
    ["LL-MIAMIAIR-US", "MG-MIAMIAIRLEASEIN-US"],
    ["LW-LAUDAEUROPE-MT", "OE-LAUDAMOTIONGMBH-AT"],
    ["MCS-MCSAEROCARGADEM-MX", "T8-MCSAEROCARGADEM-MX"],
    ["ML-AIRMEDITERRANEE-FR", "MV-AIRMEDITERRANEA-GR"],
    ["MNE-AIRMONTENEGRO-ME", "YM-AIRMONTENEGRO-ME"],
    ["MRR-SANJUANAIRLINES-US", "SJN-SANJUANAIRLINES-US"],
    ["N3-VUELAELSALVADOR-SV", "VOC-VOLARISCOSTARIC-CR", "Y4-VOLARIS-MX"],
    ["N9-NOVAIR-SE", "NG-NOVAIRLIMITEDLI-AM", "VQ-NOVOAIR-BD"],
    ["N9-SHREEAIRLINES-NP", "SHA-SHREEAIRLINES-NP"],
    ["NA-NESMAAIRLINESCO-SA", "NE-NESMAAIRLINES-EG"],
    ["NR-MAXAIR-NG", "UY-MAXAIRSA-UY", "VM-MAXAIR-NG"],
    ["NYT-YETIAIRLINES-NP", "YT-YETIAIRLINES-NP"],
    ["NZ-AIRNEWZEALAND-NZ", "NZL-AIRNEWZEALANDLI-NZ"],
    ["O3-SFAIRLINES-CN", "S7-S7AIRLINES-RU"],
    ["OF-OVERLANDAIRWAYS-NG", "OJ-OVERLANDAIRWAYS-NG"],
    ["OL-POLYNESIANAIRLI-DE", "PAO-POLYNESIANAIRLI-WS"],
    ["4I-IZAIR-TR", "OP-AIRPEGASUSPVTLT-IN", "PC-PEGASUSAIRLINES-TR", "PPL-AIRPEGASUSPVTLT-IN"],
    ["OTJ-TENAIRWAYS-RO", "X5-FLYROMANIA-RO"],
    ["P3-PORTERAIRLINESI-CA", "PD-PORTERAIRLINESI-CA"],
    ["P8-SPRINTAIR-PL", "SRN-SPRINTAIRSA-PL"],
    ["PB-PROVINCIALAIRLI-CA", "RA-NEPALAIRLINESCO-NP"],
    ["PI-SOLDELPARAGUAYL-PY", "SGU-SOLDELPARAGUAY-PY"],
    ["Q2-MALDIVIAN-MV", "TMW-TRANSMALDIVIAN-MV"],
    ["Q6-SKYTRANS-AU", "SKP-SKYTRANSAIRLINE-AU"],
    ["Q9-WATANIYAAIRWAYS-KW", "WAN-WATANIYAAIRWAYS-KW"],
    ["KR-KYRGYZAIRWAYS-KG", "LK-KYRGYZAIRLINES-KG", "QH-AIRKYRGYZSTAN-KG", "QH-KYRGYZSTAN-KG"],
    ["QNZ-JETCONNECT-NZ", "S2-JETLITE-IN"],
    ["QY-EUROPEANAIRTRAN-BE", "QY-EUROPEANAIRTRAN-DE"],
    ["R0-TANTALUSAIR-CA", "TTU-TANTALUSAIR-CA"],
    ["R5-JORDANAVIATION-JO", "R5-JORDANAVIATIONA-JO"],
    ["RE-STOBARTAIR-IE", "STK-STOBARTAIR-IE"],
    ["RFJ-ROYALFALCON-JO", "RL-ROYALFALCON-JO"],
    ["RG-VARIG-BR", "VLO-VARIGLOGISTICA-BR"],
    ["RNX-1TIME-ZA", "T6-1TIME-ZA"],
    ["RSI-AIRSUNSHINE-US", "YI-AIRSUNSHINE-US"],
    ["S2-SERVEAIRSARL-CG", "V6-SERVEAIR-CG"],
    ["SAY-SKYGATESAIRLINE-RU", "U3-AIRCOMPANYSKYGA-RU"],
    ["SB-AIRCALEDONIEINT-NC", "TY-AIRCALEDONIE-NC"],
    ["SN-BRUSSELSAIRLINE-BE", "TV-BRUSSELSAIRLINE-BE"],
    ["SVI-SKYVISIONAIRLIN-EG", "V2-VISIONAIRLINES-US"],
    ["SXD-SUNEXPRESSDEUTS-DE", "XQ-SUNEXPRESS-TR"],
    ["T5-TURKMENISTANAIR-TM", "TUA-TURKMENISTANAIR-TM"],
    ["T6-ISLANDTRANSVOYA-PH", "WQ-SWIFTAIR-US", "WT-SWIFTAIR-ES"],
    ["TN-AIRTAHITINUI-PF", "VT-AIRTAHITI-PF"],
    ["TU-TUNISAIR-TN", "UG-TUNISAIREXPRESS-TN"],
    ["UG-SEVENAIR-TN", "WV-AEROVIP-PT"],
    ["UX-AIREUROPA-ES", "X5-AIREUROPAEXPRES-ES"],
    ["V6-VIPSA-EC", "VUR-VIPSA-EC"],
    ["VAW-FLY2SKY-BG", "VAW-FLY2SKY-DK"],
    ["VG-CITYJET-BE", "WX-CITYJET-IE"],
    ["VV-AEROSVITAIRLINE-UA", "VV-PRIVATEJSCAEROS-UA"],
    ["WR-WESTJETENCORE-CA", "WS-WESTJET-CA"],
    ["X8-AVIONEXPRESSMAL-MT", "X9-AVIONEXPRESS-LT"],
    ["2O-ISLANDAIRSERVIC-US", "ISA-ISLANDAIRLINESI-US", "WP-ISLANDAIR-US"],
    ["FJ-AIRPACIFIC-FJ", "FJ-FIJIAIRWAYS-FJ"],
    ["OG-ONETWOGOAIRLINE-TH", "OX-ORIENTTHAIAIRLI-TH"],
    ["8Z-CONGOAIRWAYS-CD", "ZC-KORONGOAIRLINES-CD"],
    ["M0-AEROMONGOLIA-MN", "MNG-AEROMONGOLIA-MN"],
    ["EQ-FLYANGOLA-AO", "FLA-FLYANGOLA-AO"],
    ["AU-AUSTRAL-AR", "UU-AIRAUSTRAL-RE"],
    ["AA-AMERICANAIRLINE-US", "US-USAIRWAYS-US"],
    ["ET-ETHIOPIANAIRLIN-ET", "KP-ASKYAIRLINES-TG"],
    ["R9-SUASAAIRLINES-MY", "RZ-SANSAAIRLINES-CR"],
    ["7L-SILKWAYWESTAIRL-AZ", "ZP-SILKWAYAIRLINES-AZ"],
    ["Q9-ARIKNIGER-NE", "W3-ARIKAIR-NG"],
    ["5L-TRANSPORTESAERE-CR", "5U-TRANSPORTESAERE-GT", "VW-TRANSPORTESAERO-MX"],
    ["LF-LAOCENTRALAIRLI-LA", "LK-LAOSKYWAY-LA", "QV-LAOAIRLINES-LA"],
    ["PDT-PIEDMONTSOUTHER-US", "PT-PIEDMONTAIRLINE-US"],
    ["VJ-VIETJETAIR-VN", "VZ-THAIVIETJETAIR-TH"],
    ["TMT-TITANAIRWAYSMAL-MT", "ZT-TITANAIRWAYS-GB"],
    ["9Y-AXISINTERNATION-CM", "O8-AXISLINES-CM"],
    ["JTU-ZHETYSU-KZ", "ZAV-ZHETSYU-KZ"],
    [
      "FC-VIVACOLOMBIA-CO",
      "VB-VIVAAEROBUS-MX",
      "VPE-VIVAAIRPERU-PE",
      "VV-VIVAAIRLINESPER-PE",
      "VVC-VIVACOLOMBIA-CO",
      "ZG-VIVAMACAU-MO",
    ],
    ["QF-QANTASAIRWAYS-AU", "QLK-QANTASLINK-AU"],
    ["HV-TRANSAVIACOM-NL", "PH-TRANSAVIADENMAR-DK", "TO-TRANSAVIACOMFRA-FR"],
    ["A5-HOP-FR", "AF-AIRFRANCE-FR"],
    ["4P-REGIONALSKY-US", "KV-SKYREGIONAL-CA"],
    ["DJ-VIRGINAUSTRALIA-AU", "VA-VIRGINAUSTRALIA-AU"],
    ["A0-BAEUROFLYERDBAB-GB", "BA-BRITISHAIRWAYS-GB"],
    ["LX-SWISSINTERNATIO-CH", "SWU-SWISSGLOBALAIRL-CH"],
    ["4T-BELAIRAIRLINES-CH", "AB-AIRBERLIN-DE"],
  ],
  map: {
    "RNX-1TIME-ZA": 204,
    "T6-1TIME-ZA": 204,
    "AYD-ABAVIATION-KM": 83,
    "KP-ASKYAIRLINES-TG": 232,
    "AG-ASLAIRLINESIREL-IE": 35,
    "FAT-ASLAIRLINESSWIT-CH": 35,
    "9V-AVIORAIRLINES-VE": 19,
    "3R-AVIORREGIONAL-VE": 19,
    "RGR-AVIORREGIONAL-VE": 19,
    "Y6-ABAVIATION-KM": 83,
    "EI-AERLINGUS-IE": 119,
    "EG-AERLINGUSUKLIMI-GB": 119,
    "M0-AEROMONGOLIA-MN": 228,
    "A4-AEROCON-BO": 69,
    "NIG-AEROCONTRACTORS-NG": 69,
    "CPR-AEROLINEADELCAR-PE": 73,
    "ACL-AEROLINEADELCAR-CO": 73,
    "JK-AEROLINEADELCAR-CO": 73,
    "AM-AEROMEXICO-MX": 33,
    "5D-AEROMEXICOCONNE-MX": 33,
    "8CY-AEROMEXPRESS-MX": 59,
    "MPX-AEROMEXPRESS-MX": 59,
    "MNG-AEROMONGOLIA-MN": 228,
    "APP-AEROPERLAS-PA": 78,
    "WL-AEROPERLAS-PA": 78,
    "VV-AEROSVITAIRLINE-UA": 221,
    "HN-AFGHANAIRLINES-AF": 129,
    "G9-AIRARABIA-AE": 17,
    "3L-AIRARABIAABUDHA-AE": 17,
    "E5-AIRARABIAEGYPT-EG": 17,
    "9P-AIRARABIAJORDAN-JO": 17,
    "3O-AIRARABIAMAROC-MA": 17,
    "UU-AIRAUSTRAL-RE": 230,
    "AB-AIRBERLIN-DE": 251,
    "TY-AIRCALEDONIE-NC": 208,
    "SB-AIRCALEDONIEINT-NC": 208,
    "AC-AIRCANADA-CA": 72,
    "QK-AIRCANADAJAZZ-CA": 72,
    "RV-AIRCANADAROUGE-CA": 72,
    "LB-AIRCOSTA-IN": 169,
    "RI-AIRCOSTARICA-CR": 169,
    "DJ-AIRDJIBOUTI-DJ": 107,
    "UX-AIREUROPA-ES": 217,
    "X5-AIREUROPAEXPRES-ES": 217,
    "AF-AIRFRANCE-FR": 246,
    "A5-HOP-FR": 246,
    "EO-AIRGO-EG": 37,
    "EO-AIRGOAIRLINESEG-EG": 37,
    "HAT-AIRHORIZONT-MT": 115,
    "NY-AIRICELAND-IS": 120,
    "AI-AIRINDIA-IN": 75,
    "I5-AIRASIAINDIA-IN": 75,
    "IX-AIRINDIAEXPRESS-IN": 75,
    "I9-AIRITALY-IT": 55,
    "IG-MERIDIANAFLYSPA-IT": 55,
    "QH-AIRKYRGYZSTAN-KG": 196,
    "8CX-AIRLIAISON-CA": 58,
    "LIZ-AIRLIAISON-CA": 58,
    "LSJ-AIRLIAISON-CA": 58,
    "MAX-AIRLIAISON-CA": 58,
    "DR-AIRLINK-AU": 30,
    "LZ-AIRLINK-AU": 30,
    "MV-AIRMEDITERRANEA-GR": 174,
    "ML-AIRMEDITERRANEE-FR": 174,
    "MNE-AIRMONTENEGRO-ME": 175,
    "NZ-AIRNEWZEALAND-NZ": 183,
    "NZL-AIRNEWZEALANDLI-NZ": 183,
    "AP-AIRONE-IT": 77,
    "CT-AIRONECITYLINER-IT": 77,
    "FJ-AIRPACIFIC-FJ": 225,
    "OP-AIRPEGASUSPVTLT-IN": 187,
    "PPL-AIRPEGASUSPVTLT-IN": 187,
    "2P-AIRPHILIPPINES-PH": 8,
    "RSI-AIRSUNSHINE-US": 205,
    "YI-AIRSUNSHINE-US": 205,
    "VT-AIRTAHITI-PF": 214,
    "TN-AIRTAHITINUI-PF": 214,
    "6C-AIRTIMOR-TL": 43,
    "6C-AIRTIMORSA-TL": 43,
    "DO-AIRVALLEE-IT": 109,
    "VK-AIRVALLEE-IT": 109,
    "AK-AIRASIA-MY": 76,
    "JW-AIRASIAJAPANCOL-JP": 76,
    "PQ-AIRASIAPHILIPPI-PH": 76,
    "YM-AIRMONTENEGRO-ME": 175,
    "KT-AIRASIACAMBODIA-KH": 76,
    "DJ-AIRASIAJAPAN-JP": 76,
    "D7-AIRASIAX-MY": 76,
    "Z2-AIRASIAZEST-PH": 76,
    "ARB-AIRBAHNINC-US": 79,
    "UN-AIRBAHNINC-US": 79,
    "4Z-SOUTHAFRICANAIR-ZA": 30,
    "T6-ISLANDTRANSVOYA-PH": 213,
    "6N-ALNASERAIRLINES-JO": 45,
    "NR-ALNASERAIRLINES-IQ": 45,
    "D4-ALIDAUNIA-IT": 103,
    "LID-ALIDAUNIA-IT": 103,
    "CT-ALITALIACITYLIN-IT": 55,
    "9I-AIRINDIAREGIONA-IN": 12,
    "QQ-ALLIANCEAIRLINE-AU": 12,
    "3A-ALLIANCEAIRLINE-US": 12,
    "BIC-ALPHALANDAVIATI-PH": 88,
    "C9-ALPHALANDAVIATI-PH": 88,
    "Z8-AMASZONAS-BO": 81,
    "ZP-AMASZONASLINEAA-BO": 81,
    "AUZ-AMASZONASURUGUA-UY": 81,
    "AA-AMERICANAIRLINE-US": 231,
    "M6-AMERIJETINTERNA-US": 158,
    "FG-ARIANAAFGHANAIR-AF": 129,
    "W3-ARIKAIR-NG": 235,
    "Q9-ARIKNIGER-NE": 235,
    "JI-ARMENIANAIRLINE-AM": 74,
    "P9-ASIAPACIFICAIRL-GU": 51,
    "DM-ASIANAIR-TH": 76,
    "YJ-ASIANWINGSAIRWA-MM": 46,
    "3V-TNTAIRWAYSSA-BE": 35,
    "5O-EUROPEAIRPOST-FR": 35,
    "5O-ASLAIRLINESFRAN-FR": 35,
    "8V-ASTRALAVIATION-KE": 62,
    "8Y-ASTROAIRINTERNA-PH": 51,
    "AEU-ATLANTISARMENIA-AM": 74,
    "2R-ATLANTISEUROPEA-RO": 9,
    "TD-ATLANTISEUROPEA-AM": 9,
    "EA-ATLANTISAIRLINK-CA": 30,
    "KK-ATLASJETAIRLINE-TR": 163,
    "UH-AIRCOMPANYATLAS-UA": 163,
    "UI-AURICAIR-TZ": 148,
    "H8-AURICAIRSERVICE-TZ": 148,
    "AU-AUSTRAL-AR": 230,
    "AV-AVIANCA-CO": 6,
    "A0-AVIANLINEASAERE-AR": 6,
    "ANC-AVIANCAARGENTIN-AR": 6,
    "O6-OCEANAIR-BR": 6,
    "LR-LACSALINEASAERE-CR": 6,
    "T0-TRANSAMERICANAI-PE": 6,
    "2K-AEROGAL-EC": 6,
    "X9-AVIONEXPRESS-LT": 223,
    "X8-AVIONEXPRESSMAL-MT": 223,
    "9Y-AXISINTERNATION-CM": 241,
    "O8-AXISLINES-CM": 241,
    "AD-AZULAIRLINES-BR": 5,
    "2F-TWOTAXIAEREOLTD-BR": 5,
    "V6-BVIAIRLINK-VG": 30,
    "XV-BVIAIRWAYS-VG": 29,
    "A0-BAEUROFLYERDBAB-GB": 249,
    "ID-BATIKAIR-ID": 155,
    "OD-BATIKAIRMALAYSI-MY": 155,
    "B5-BBNAIRLINES-TR": 49,
    "7B-BBNAIRLINESINDO-ID": 49,
    "7B-BEESAIRLINE-UA": 50,
    "E8-BEESAIRLINES-RO": 50,
    "4T-BELAIRAIRLINES-CH": 251,
    "LZ-BELLEAIR-AL": 168,
    "L9-BELLEAIREUROPE-IT": 168,
    "B3-BHUTANAIRLINES-BT": 85,
    "BTN-BHUTANAIRLINES-BT": 85,
    "5Z-BISMILLAHAIRLIN-BD": 41,
    "BH-BISMILLAHAIRLIN-BD": 41,
    "BRJ-BORAJET-TR": 89,
    "YB-BORAJET-TR": 89,
    "BU-BRAATHENSASA-NO": 71,
    "TT-BRAATHENSINTERN-SE": 71,
    "DC-BRAATHENSREGION-SE": 71,
    "TF-BRAATHENSREGION-SE": 71,
    "BA-BRITISHAIRWAYS-GB": 249,
    "SN-BRUSSELSAIRLINE-BE": 209,
    "TV-BRUSSELSAIRLINE-BE": 209,
    "4V-BVIAIRWAYS-VG": 29,
    "XK-CCMAIRLINES-FR": 95,
    "CC-CMAIRLINES-HN": 95,
    "CRA-CRONOSAIR-GQ": 93,
    "CPN-CASPIANAIRLINES-IR": 98,
    "RV-CASPIANAIRLINES-IR": 98,
    "DG-CEBGO-PH": 34,
    "5J-CEBUPACIFICAIR-PH": 34,
    "5C-CALCARGOAIRLINE-IL": 32,
    "X7-ACEBELGIUMFREIG-BE": 32,
    "6Q-CHAMWINGSAIRLIN-SY": 46,
    "KN-CHINAUNITEDAIRL-CN": 164,
    "QI-CIMBERSTERLING-DK": 108,
    "WX-CITYJET-IE": 220,
    "VG-CITYJET-BE": 220,
    "CQ-COASTALAVIATION-TZ": 62,
    "9L-COLGANAIR-US": 66,
    "CJC-COLGANAIR-US": 66,
    "DE-CONDORFLUGDIENS-DE": 105,
    "DF-CONDORBERLIN-DE": 105,
    "8Z-CONGOAIRWAYS-CD": 227,
    "C4-CONQUESTAIRINC-US": 92,
    "QAI-CONQUESTAIRINC-US": 92,
    "XC-CORENDONAIRLINE-TR": 97,
    "CXI-CORENDONAIRLINE-MT": 97,
    "CND-CORENDONDUTCHAI-NL": 97,
    "CRG-COSTARICAGREENA-CR": 99,
    "GW-COSTARICAGREENA-CR": 99,
    "C8-CRONOSAIR-GQ": 93,
    "OK-CZECHAIRLINES-CZ": 150,
    "DX-DANISHAIRTRANSP-DK": 112,
    "D3-DAALLOAIRLINES-DJ": 102,
    "D9-DAALLOAIRLINESS-SO": 102,
    "R6-DOTLT-LT": 112,
    "Q7-DHLAIRAUSTRIAGM-AT": 101,
    "D0-DHLAIR-GB": 101,
    "DZ-DJIBOUTIAIR-DJ": 107,
    "DH-DOUNIAHAIRLINES-ML": 106,
    "DTS-DOUNIAHAIRLINES-ML": 106,
    "LC-ECAIR-CG": 121,
    "EGU-EAGLEAIR-UG": 120,
    "H7-EAGLEAIR-UG": 120,
    "FEI-EAGLEAIRICELAND-IS": 120,
    "EA-EASTHORIZONAIRL-AF": 115,
    "EHN-EASTHORIZONAIRL-AF": 115,
    "ZE-EASTARJET-KR": 124,
    "2D-DYNAMICAIRWAYS-US": 3,
    "EAL-EASTERNAIRLINES-US": 3,
    "EE-EASTERNSKYJETS-AE": 118,
    "ESJ-EASTERNSKYJETS-AE": 118,
    "EJ-ECAIR-CG": 121,
    "E7-EQUAFLIGHT-CD": 114,
    "L8-EQUAFLIGHTGABON-GA": 114,
    "ET-ETHIOPIANAIRLIN-ET": 232,
    "EMZ-ETHIOPIANMOZAMB-MZ": 123,
    "ZU-ETHIOPIANMOZAMB-MZ": 123,
    "6Z-EUROASIAAIR-KZ": 31,
    "5B-EUROASIAAIRINTE-KZ": 31,
    "BUC-EUROPEANAIRCHAR-BG": 90,
    "H6-BULGARIANAIRCHARTER-BG": 90,
    "QY-EUROPEANAIRTRAN-BE": 198,
    "QY-EUROPEANAIRTRAN-DE": 198,
    "ECB-EUROPEANCOASTAL-HR": 117,
    "WL-EUROPEANCOASTAL-HR": 117,
    "EW-EUROWINGS-DE": 113,
    "EWE-EUROWINGSEUROPE-AT": 113,
    "E6-EUROWINGSEUROPE-MT": 113,
    "WEW-EXPRESSAIR-CA": 64,
    "EPR-EXPRESSAIRWAYS-DE": 64,
    "FT-FARNAIRSWITZERL-CH": 127,
    "FAT-FARNAIRSWITZERL-CH": 127,
    "FO-FELIXAIRWAYS-YE": 135,
    "FXX-FELIXAIRWAYS-YE": 135,
    "FJ-FIJIAIRWAYS-FJ": 225,
    "FC-FINNCOMMAIRLINE-FI": 128,
    "WBA-FINNCOMMAIRLINE-FI": 128,
    "EQ-FLYANGOLA-AO": 229,
    "FLA-FLYANGOLA-AO": 229,
    "FLB-FLYART-TD": 133,
    "T2-FLYART-TD": 133,
    "VAW-FLY2SKY-DK": 219,
    "VAW-FLY2SKY-BG": 219,
    "5F-FLYONESRL-MD": 13,
    "OE-FLYONEAIRLINES-RO": 13,
    "FZW-FLYAFRICAZIMBAB-ZW": 138,
    "FLG-FLYBIG-IN": 134,
    "S9-FLYBIG-IN": 134,
    "4J-FLYDAMASAIRLINE-SY": 25,
    "FDK-FLYDAMASAIRLINE-SY": 25,
    "FGG-FLYGLOBALCHARTE-MY": 130,
    "FS-FLYGLOBALCHARTE-MY": 130,
    "3F-FLYONEARMENIA-AM": 13,
    "FH-FREEBIRDAIRLINE-TR": 131,
    "FHM-FREEBIRDAIRLINE-MT": 131,
    "FP-FREEDOMAIR-GU": 26,
    "FDT-FREEDOMAIRLINEE-KE": 26,
    "4K-FREEDOMAIRLINEE-SO": 26,
    "FDM-FREEDOMAIRLINES-US": 26,
    "F9-FRONTIERAIRLINE-US": 4,
    "2F-FRONTIERFLYINGS-US": 4,
    "FTA-FRONTIERFLYINGS-US": 4,
    "G6-GHADAMESAIRTRAN-LY": 140,
    "NJ-GHADAMESAIRTRAN-LY": 140,
    "QG-GLOBALAVIATION-ZA": 39,
    "GE-GLOBALAVIATIONO-ZA": 39,
    "5S-GLOBALAVIATIONA-LY": 39,
    "XT-GLOBUS-RU": 141,
    "GH-GLOBUSLLC-RU": 141,
    "G8-GOAIR-IN": 37,
    "G8-GOFIRST-IN": 37,
    "L4-GRUPOLASASRL-AR": 167,
    "NQN-GRUPOLASASRL-AR": 167,
    "GX-GUANGXIBEIBUGUL-CN": 47,
    "GF-GULFAIR-BH": 47,
    "HR-HAHNAIR-DE": 146,
    "H1-HAHNAIRSYSTEMS-DE": 146,
    "X1-HAHNAIRTECHNOLO-DE": 146,
    "JB-HELIJETINTERNAT-CA": 158,
    "FHE-HELLO-CH": 132,
    "H3-HELLOAIRLINES-BD": 132,
    "HLJ-HELLOJETS-RO": 132,
    "H4-HISKYEUROPESRL-RO": 147,
    "HBN-HIBERNIANAIRLIN-IE": 149,
    "HG-HIBERNIANAIRLIN-IE": 149,
    "H7-HISKY-MD": 147,
    "HC-HOLIDAYSCZECHAI-CZ": 150,
    "QX-HORIZONAIR-US": 115,
    "I4-IFLYLTD-RU": 126,
    "ITY-ITAAIRWAYS-IT": 55,
    "IB-IBERIA-ES": 152,
    "I2-IBERIAEXPRESS-ES": 152,
    "QZ-INDONESIAAIRASI-ID": 76,
    "XT-INDONESIAAIRASI-ID": 76,
    "7I-INSELAIR-CW": 52,
    "8I-INSELAIRARUBA-AW": 52,
    "I7-INTERILESAIR-KM": 154,
    "IIA-INTERILESAIR-KM": 154,
    "4O-INTERJET-MX": 27,
    "K8-INTERJETWEST-US": 27,
    "I4-INTERNATIONALAI-JM": 30,
    "IR-IRANAIR-IR": 86,
    "B9-IRANAIRTOURS-IR": 86,
    "WP-ISLANDAIR-US": 224,
    "2O-ISLANDAIRSERVIC-US": 224,
    "ISA-ISLANDAIRLINESI-US": 224,
    "FS-ITALIAIRLINES-IT": 55,
    "8I-ITA-BR": 55,
    "4I-IZAIR-TR": 187,
    "3X-JAPANAIRCOMMUTE-JP": 20,
    "JC-JALEXPRESS-JP": 20,
    "JL-JAPANAIRLINES-JP": 20,
    "JCC-JCCAMBODIAINTER-KH": 159,
    "QD-JCCAMBODIAINTER-KH": 159,
    "O2-JETAIR-PL": 67,
    "O2-JETAIRLTD-PL": 67,
    "9W-JETAIRWAYSINDIA-IN": 67,
    "QJ-JETAIRWAYSINC-US": 67,
    "JO-JETTIME-DK": 161,
    "QNZ-JETCONNECT-NZ": 197,
    "S2-JETLITE-IN": 197,
    "JA-JETSMART-CL": 157,
    "JZ-JETSMARTAIRLINE-PE": 157,
    "WJ-JETSMARTAIRLINE-AR": 157,
    "J6-JETSMARTAIRLINE-CO": 157,
    "JQ-JETSTARAIRWAYS-AU": 16,
    "3K-JETSTARASIA-SG": 16,
    "GK-JETSTARJAPAN-JP": 16,
    "JP-JETTIME-DK": 161,
    "LJ-JINAIR-KR": 145,
    "8CR-JONAIR-SE": 57,
    "JON-JONAIR-SE": 57,
    "JN-JOON-FR": 160,
    "JON-JOON-FR": 160,
    "R5-JORDANAVIATION-JO": 200,
    "R5-JORDANAVIATIONA-JO": 200,
    "3J-JUBBAAIRWAYS-SO": 15,
    "JUB-JUBBAAIRWAYS-SO": 15,
    "3J-JUBBAAIRWAYSLTD-KE": 15,
    "WA-KLMCITYHOPPER-NL": 70,
    "KL-KLMROYALDUTCHAI-NL": 70,
    "UK-KLMUK-GB": 70,
    "K4-KALITTAAIR-US": 11,
    "K5-KALITTACHARTERS-US": 11,
    "K9-KALITTACHARTERS-US": 11,
    "IRG-IRANIANNAFTAIRL-IR": 156,
    "KRU-KARUNAIRLINES-IR": 156,
    "KNW-KENAIAVIATIONOP-US": 165,
    "KW-KENAIAVIATIONOP-US": 165,
    "ZC-KORONGOAIRLINES-CD": 227,
    "LK-KYRGYZAIRLINES-KG": 196,
    "KR-KYRGYZAIRWAYS-KG": 196,
    "QH-KYRGYZSTAN-KG": 196,
    "QL-LASERAIRLINES-VE": 45,
    "LA-LANAIRLINES-CL": 40,
    "JJ-TAMLINHASAEREAS-BR": 40,
    "4C-AIRES-CO": 40,
    "XL-LANECUADOR-EC": 40,
    "PZ-TRANSPORTESAERE-PY": 40,
    "LP-LANPERU-PE": 40,
    "QV-LAOAIRLINES-LA": 237,
    "LF-LAOCENTRALAIRLI-LA": 237,
    "LK-LAOSKYWAY-LA": 237,
    "OE-LAUDAMOTIONGMBH-AT": 172,
    "LW-LAUDAEUROPE-MT": 172,
    "LV-LEVEL-ES": 116,
    "VK-ANISECLUFTFAHRT-AT": 116,
    "EC-OPENSKIES-GB": 116,
    "JT-LIONAIR-ID": 162,
    "L0-LIZAVIATIONBF-BF": 166,
    "LAZ-LIZAVIATIONBF-BF": 166,
    "F7-LTDIFLY-RU": 126,
    "LH-LUFTHANSAGERMAN-DE": 96,
    "VL-CITYAIRLINES-DE": 96,
    "CL-LUFTHANSACITYLI-DE": 96,
    "Y9-ENERJET-CA": 48,
    "CC-MACAIR-AU": 68,
    "A0-MACAIRJET-AR": 68,
    "MCJ-MACAIRJET-AR": 68,
    "Q2-MALDIVIAN-MV": 193,
    "NR-MAXAIR-NG": 181,
    "VM-MAXAIR-NG": 181,
    "UY-MAXAIRSA-UY": 181,
    "2M-MAYAISLANDAIR-BZ": 7,
    "MY-MAYAISLANDAIR-BZ": 7,
    "MCS-MCSAEROCARGADEM-MX": 173,
    "T8-MCSAEROCARGADEM-MX": 173,
    "XN-MEXICANA-MX": 153,
    "I6-MEXICANAINTER-MX": 153,
    "MX-MEXICANADEAVIAC-MX": 153,
    "LL-MIAMIAIR-US": 171,
    "MG-MIAMIAIRLEASEIN-US": 171,
    "7N-NATIONALAIRWAYS-ET": 54,
    "9Y-NATIONALAIRWAYS-ET": 54,
    "NAE-NATIONALAIRWAYS-ET": 54,
    "RA-NEPALAIRLINESCO-NP": 191,
    "NE-NESMAAIRLINES-EG": 180,
    "NA-NESMAAIRLINESCO-SA": 180,
    "EJ-NEWENGLANDAIRLI-US": 122,
    "NEA-NEWENGLANDAIRLI-US": 122,
    "7H-ERAAVIATION-US": 51,
    "AY-NORDICREGIONALA-FI": 82,
    "N7-NORDICREGIONALA-FI": 82,
    "D8-NORWEGIAN-SE": 104,
    "DY-NORWEGIANAIRSHU-NO": 104,
    "N9-NOVAIR-SE": 178,
    "NG-NOVAIRLIMITEDLI-AM": 178,
    "VQ-NOVOAIR-BD": 178,
    "OG-ONETWOGOAIRLINE-TH": 226,
    "OX-ORIENTTHAIAIRLI-TH": 226,
    "ON-OURAIRLINE-NR": 139,
    "OF-OVERLANDAIRWAYS-NG": 185,
    "OJ-OVERLANDAIRWAYS-NG": 185,
    "BL-JETSTARPACIFICA-VN": 51,
    "PB-PROVINCIALAIRLI-CA": 191,
    "PC-PEGASUSAIRLINES-TR": 187,
    "4B-PERIMETERAVIATI-CA": 22,
    "JV-BEARSKINLAKEAIR-CA": 22,
    "YP-PERIMETERAVIATI-CA": 22,
    "PR-PHILIPPINEAIRLI-PH": 8,
    "Z2-ZESTAIR-PH": 76,
    "PH-PHOENIXAIRGROUP-US": 144,
    "GRB-PHOENIXAIRGROUP-US": 144,
    "PT-PIEDMONTAIRLINE-US": 238,
    "PDT-PIEDMONTSOUTHER-US": 238,
    "OL-POLYNESIANAIRLI-DE": 186,
    "PAO-POLYNESIANAIRLI-WS": 186,
    "P3-PORTERAIRLINESI-CA": 189,
    "PD-PORTERAIRLINESI-CA": 189,
    "0J-PREMIUMJET-DE": 0,
    "0J-PREMIUMJETAG-CH": 0,
    "PF-PRIMERAAIR-DK": 44,
    "6F-PRIMERAAIRNORDI-LV": 44,
    "VV-PRIVATEJSCAEROS-UA": 221,
    "8W-PRIVATEWINGS-DE": 63,
    "JW-PRIVATEWINGSFLU-DE": 63,
    "QF-QANTASAIRWAYS-AU": 244,
    "QLK-QANTASLINK-AU": 244,
    "5R-RUTACA-VE": 38,
    "RUC-RUTACA-VE": 38,
    "WZ-REDWINGSAIRLINE-RU": 46,
    "8N-REGIONALAIRSERV-TZ": 60,
    "REG-REGIONALAIRSERV-TZ": 60,
    "ZL-REGIONALEXPRESS-AU": 125,
    "EX-REGIONALEXPRESS-CO": 125,
    "4P-REGIONALSKY-US": 247,
    "KB-DRUKAIR-BT": 85,
    "RFJ-ROYALFALCON-JO": 202,
    "RL-ROYALFALCON-JO": 202,
    "FR-RYANAIR-IE": 136,
    "RK-RYANAIRUKLTD-GB": 136,
    "S7-S7AIRLINES-RU": 184,
    "RZ-SANSAAIRLINES-CR": 233,
    "O3-SFAIRLINES-CN": 184,
    "LX-SWISSINTERNATIO-CH": 250,
    "MRR-SANJUANAIRLINES-US": 176,
    "SJN-SANJUANAIRLINES-US": 176,
    "6S-SAUDIGULFAIRLIN-SA": 47,
    "CB-SCOTAIRWAYS-GB": 94,
    "SAY-SCOTAIRWAYS-GB": 94,
    "V6-SERVEAIR-CG": 206,
    "S2-SERVEAIRSARL-CG": 206,
    "WV-AEROVIP-PT": 216,
    "UG-SEVENAIR-TN": 216,
    "N9-SHREEAIRLINES-NP": 179,
    "SHA-SHREEAIRLINES-NP": 179,
    "ZP-SILKWAYAIRLINES-AZ": 234,
    "7L-SILKWAYWESTAIRL-AZ": 234,
    "SLD-SILVERAIR-CZ": 18,
    "3M-SILVERAIRWAYSCO-US": 18,
    "H2-SKYAIRLINE-CL": 91,
    "ZY-SKYAIRLINES-TR": 91,
    "H8-SKYAIRLINESPERU-PE": 91,
    "XW-SKYEXPRESS-RU": 143,
    "GQ-SKYEXPRESSSA-GR": 143,
    "SAY-SKYGATESAIRLINE-RU": 207,
    "U3-AIRCOMPANYSKYGA-RU": 207,
    "DU-SKYJETMGINC-CA": 111,
    "Q9-SKYJETMGINC-CA": 111,
    "Y3-SKYKGAIRLINES-KG": 91,
    "KV-SKYREGIONAL-CA": 247,
    "SVI-SKYVISIONAIRLIN-EG": 210,
    "ND-SKYWINGSAIRLINE-GR": 46,
    "XT-SKYSTARAIRWAYS-TH": 1,
    "Q6-SKYTRANS-AU": 194,
    "SKP-SKYTRANSAIRLINE-AU": 194,
    "JZ-SKYWAYS-SE": 151,
    "HS-SKYWAYSREGIONAL-SE": 151,
    "OO-SKYWESTAIRLINES-US": 53,
    "XR-SKYWESTAIRLINES-AU": 53,
    "P7-SMALLPLANETAIRL-PL": 36,
    "RD-SMALLPLANETAIRL-KH": 36,
    "S5-SMALLPLANETAIRL-LT": 36,
    "5P-SMALLPLANETAIRL-DE": 36,
    "6Y-SMARTLYNXAIRLIN-LV": 48,
    "MYX-SMARTLYNXAIRLIN-EE": 48,
    "LYX-SMARTLYNXAIRLIN-MT": 48,
    "QS-SMARTWINGS-CZ": 21,
    "7O-SMARTWINGSHUNGA-HU": 21,
    "3Z-TRAVELSERVICEPO-PL": 21,
    "6D-TRAVELSERVICESL-SK": 21,
    "SGU-SOLDELPARAGUAY-PY": 192,
    "8R-SOLLINEASAEREAS-AR": 61,
    "FQ-SOLSALINEASAERE-AR": 61,
    "PI-SOLDELPARAGUAYL-PY": 192,
    "9C-SPRINGAIRLINES-CN": 65,
    "IJ-SPRINGAIRLINESJ-JP": 65,
    "P8-SPRINTAIR-PL": 190,
    "SRN-SPRINTAIRSA-PL": 190,
    "4E-STABOAIR-ZM": 23,
    "SBO-STABOAIR-ZM": 23,
    "OG-GHODAWATENTERPR-IN": 1,
    "SDG-STARAIR-IN": 1,
    "SRR-STARAIRAS-DK": 1,
    "SNB-STERLING-DK": 108,
    "DM-STERLINGBLUE-DK": 108,
    "RE-STOBARTAIR-IE": 201,
    "STK-STOBARTAIR-IE": 201,
    "R9-SUASAAIRLINES-MY": 233,
    "S6-SUNAIR-SD": 87,
    "EZ-SUNAIROFSCANDIN-DK": 87,
    "XQ-SUNEXPRESS-TR": 211,
    "SXD-SUNEXPRESSDEUTS-DE": 211,
    "S6-SUNRISEAIRWAYS-HT": 28,
    "D6-SERVICIOSAEREOS-DO": 28,
    "IU-SWITALIASPA-IT": 55,
    "WQ-SWIFTAIR-US": 213,
    "WT-SWIFTAIR-ES": 213,
    "SWU-SWISSGLOBALAIRL-CH": 250,
    "FS-SYPHAXAIRLINES-TN": 137,
    "SYA-SYPHAXAIRLINES-TN": 137,
    "LCT-TARAEROLINEAS-MX": 170,
    "TOM-THOMSONAIRWAYS-GB": 42,
    "X3-TUIFLY-DE": 42,
    "TB-JETAIRFLY-BE": 42,
    "OR-TUIFLYNETHERLAN-NL": 42,
    "6B-TUIFLYNORDIC-SE": 42,
    "4E-TANANAAIRSERVIC-US": 24,
    "TNR-TANANAAIRSERVIC-US": 24,
    "R0-TANTALUSAIR-CA": 199,
    "TTU-TANTALUSAIR-CA": 199,
    "YQ-TARAEROLINEAS-MX": 170,
    "OTJ-TENAIRWAYS-RO": 188,
    "X5-FLYROMANIA-RO": 188,
    "FD-THAIAIRASIA-TH": 76,
    "ESS-THAIEASTARJET-TH": 124,
    "SL-THAILIONAIR-TH": 162,
    "VZ-THAIVIETJETAIR-TH": 239,
    "MT-THOMASCOOKAIRLI-GB": 100,
    "CTB-THOMASCOOKAIRLI-ES": 100,
    "H5-THOMASCOOKAIRLI-ES": 100,
    "GS-TIANJINAIRLINES-CN": 145,
    "TT-TIGERAIRWAYSAUS-AU": 80,
    "TT-TIGERAIRAUSTRAL-AU": 80,
    "DG-TIGERAIRPHILIPP-PH": 80,
    "IT-TIGERAIRTAIWANC-TW": 80,
    "ZT-TITANAIRWAYS-GB": 240,
    "TMT-TITANAIRWAYSMAL-MT": 240,
    "TMW-TRANSMALDIVIAN-MV": 193,
    "TNU-TRANSNUSA-ID": 56,
    "HV-TRANSAVIACOM-NL": 245,
    "TO-TRANSAVIACOMFRA-FR": 245,
    "8B-TRANSNUSA-ID": 56,
    "5U-TRANSPORTESAERE-GT": 236,
    "5L-TRANSPORTESAERE-CR": 236,
    "VW-TRANSPORTESAERO-MX": 236,
    "GM-TRIMGAIRLINES-ID": 142,
    "TMG-TRIMGAIRLINES-ID": 142,
    "TU-TUNISAIR-TN": 215,
    "UG-TUNISAIREXPRESS-TN": 215,
    "T5-TURKMENISTANAIR-TM": 212,
    "TUA-TURKMENISTANAIR-TM": 212,
    "US-USAIRWAYS-US": 231,
    "NYS-ULENDOAIRLINK-MW": 30,
    "UA-UNITEDAIRLINES-US": 164,
    "UD-URAIRLINES-IQ": 139,
    "U6-URALAIRLINES-RU": 139,
    "VLO-VARIGLOGISTICA-BR": 203,
    "V6-VIPSA-EC": 218,
    "RG-VARIG-BR": 203,
    "V6-VIAIRLINK-VG": 30,
    "VIL-VIAIRLINK-VG": 30,
    "V4-VIEQUESAIRLINK-PR": 30,
    "VJ-VIETJETAIR-VN": 239,
    "0V-VIETNAMAIRSERVI-VN": 2,
    "VN-VIETNAMAIRLINES-VN": 2,
    "VU-VIETRAVELAIRLIN-VN": 2,
    "VUR-VIPSA-EC": 218,
    "DJ-VIRGINAUSTRALIA-AU": 248,
    "VA-VIRGINAUSTRALIA-AU": 248,
    "V2-VISIONAIRLINES-US": 210,
    "VVC-VIVACOLOMBIA-CO": 243,
    "VPE-VIVAAIRPERU-PE": 243,
    "VV-VIVAAIRLINESPER-PE": 243,
    "ZG-VIVAMACAU-MO": 243,
    "FC-VIVACOLOMBIA-CO": 243,
    "VB-VIVAAEROBUS-MX": 243,
    "Y4-VOLARIS-MX": 177,
    "VOC-VOLARISCOSTARIC-CR": 177,
    "N3-VUELAELSALVADOR-SV": 177,
    "Q9-WATANIYAAIRWAYS-KW": 195,
    "WAN-WATANIYAAIRWAYS-KW": 195,
    "WS-WESTJET-CA": 222,
    "WR-WESTJETENCORE-CA": 222,
    "IW-WINGSAIR-ID": 46,
    "W6-WIZZAIR-HU": 14,
    "5W-WIZZAIRABUDHABI-AE": 14,
    "W4-WIZZAIRMALTA-MT": 14,
    "W9-WIZZAIRUK-GB": 14,
    "WU-WIZZAIRUKRAINE-UA": 14,
    "8Z-WIZZAIRBULGARIA-BG": 14,
    "2W-WORLD2FLY-ES": 10,
    "3P-WORLD2FLYPORTUG-PT": 10,
    "XAR-XPRESSAIR-ID": 64,
    "XN-XPRESSAIR-ID": 64,
    "NYT-YETIAIRLINES-NP": 182,
    "YT-YETIAIRLINES-NP": 182,
    "K8-ZAMBIASKYWAYS-ZM": 151,
    "ZAV-ZHETSYU-KZ": 242,
    "JTU-ZHETYSU-KZ": 242,
    "YZ-ZIMBABWEAIRLINK-ZW": 30,
    "XM-ZIMEXAVIATION-CH": 84,
    "AZD-ZIMEXAVIATIONAU-AT": 84,
    "8N-BARENTSAIRLINK-SE": 30,
    "U2-EASYJET-GB": 110,
    "EC-EASYJETEUROPEAI-AT": 110,
    "DS-EASYJETSWITZERL-CH": 110,
    "Z7-FLYAFRICAZIMBAB-ZW": 138,
    "PH-TRANSAVIADENMAR-DK": 245,
  },
};
